import { ChangeDetectionStrategy, Component,Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { DisplayByTypeDirective } from '../../../question/display-by-type.directive';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'que-display-big-title-question',
    imports: [CommonModule, TranslateDirective, TranslatePipe, DisplayByTypeDirective, SvgIconComponent],
    templateUrl: './display-big-title-question.component.html',
    styleUrls: ['./display-big-title-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayBigTitleQuestionComponent {
  @Input() question!: Question;
  @Input() isPreview=false;
  color$=inject(QuestionnaireStore).mainColor$;
}
